import { useEffect, useRef } from 'react'

export const useEffectAfterMount = (
    callback: () => void,
    dependencies: React.DependencyList
) => {
    const hasMounted = useRef(false)
    const callbackRef = useRef(callback)

    useEffect(() => {
        callbackRef.current = callback
    }, [callback])

    useEffect(() => {
        if (hasMounted.current) {
            callbackRef.current()
        } else {
            hasMounted.current = true
        }
    }, dependencies) // eslint-disable-line react-hooks/exhaustive-deps
}
